import { render } from "./ContactButton.vue?vue&type=template&id=afd0658c&ts=true"
import script from "./ContactButton.vue?vue&type=script&lang=ts"
export * from "./ContactButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__